import { loadStripe } from '@stripe/stripe-js';

// Load Stripe with publishable key
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

export default stripePromise;

// Subscription plans configuration
export const SUBSCRIPTION_PLANS = {
  free: {
    id: 'free',
    name: 'Free Plan',
    price: 0,
    priceId: null,
    features: [
      '10 searches per month',
      'Basic map features',
      'Email support'
    ],
    limits: {
      searches: 10,
      mapViews: 50
    }
  },
  basic: {
    id: 'basic',
    name: 'Basic Plan',
    price: 29,
    priceId: 'price_basic_monthly', // Replace with actual Stripe price ID
    features: [
      '100 searches per month',
      'Advanced map features',
      'Email alerts',
      'Priority support'
    ],
    limits: {
      searches: 100,
      mapViews: 500
    }
  },
  pro: {
    id: 'pro',
    name: 'Pro Plan',
    price: 99,
    priceId: 'price_pro_monthly', // Replace with actual Stripe price ID
    features: [
      'Unlimited searches',
      'All map features',
      'Real-time alerts',
      'API access',
      'Phone support'
    ],
    limits: {
      searches: -1, // -1 means unlimited
      mapViews: -1
    }
  }
};

// Mock subscription data for development
export const mockSubscriptionData = {
  id: 'sub_mock123',
  status: 'active',
  current_period_start: Date.now() - (15 * 24 * 60 * 60 * 1000), // 15 days ago
  current_period_end: Date.now() + (15 * 24 * 60 * 60 * 1000), // 15 days from now
  plan: SUBSCRIPTION_PLANS.basic,
  usage: {
    searches: 23,
    mapViews: 156
  }
};